export default {
    addCompanyContact: '会社情報を追加',
    addPersonalContact: '連絡先を追加',
    archiveClient: '取引先をアーカイブ',
    delete: '削除',
    title: '取引先 - MakeLeaps',
};
